import getAccountManagementLicenceWarning from './getAccountManagementLicenceWarning/getAccountManagementLicenceWarning';
import { SURVEY_BUILDER_POPUP_TYPES } from './constants';

export default (authState, newState) => {
  const surveyPermissionsCharge =
    newState &&
    newState.newState &&
    newState.newState.surveyPermissionsCharge &&
    newState.newState.surveyPermissionsCharge[newState.newState.survey.id]
      ? newState.newState.surveyPermissionsCharge[newState.newState.survey.id]
      : {};

  const {
    accountManagementWarning,
    chargeAmount
  } = getAccountManagementLicenceWarning(
    authState.isAdmin,
    newState.newState.survey,
    newState.newState.surveyLists,
    authState.accountManagement,
    surveyPermissionsCharge
  );

  const surveyId = newState.newState.survey.id;
  const existingSurveyPermissionsCharge =
    newState.newState.surveyPermissionsCharge;
  const newStateData = {};

  // Charge amount is always updated
  newStateData.surveyPermissionsCharge = {
    ...(existingSurveyPermissionsCharge || {}),
    [surveyId]: {
      ...(existingSurveyPermissionsCharge &&
      existingSurveyPermissionsCharge[surveyId]
        ? existingSurveyPermissionsCharge[surveyId]
        : {}),
      chargeAmount
    }
  };

  if (accountManagementWarning !== null) {
    newStateData.surveyBuilderPopup = {
      type: accountManagementWarning
    };

    if (
      accountManagementWarning ===
      SURVEY_BUILDER_POPUP_TYPES.SURVEY_UNPUBLISHED_QUESTIONS_ADDED
    ) {
      newStateData.surveyPermissionsCharge = {
        ...existingSurveyPermissionsCharge,
        [surveyId]: {
          unpublishedWarningShown: true
        }
      };
    }

    if (
      accountManagementWarning ===
      SURVEY_BUILDER_POPUP_TYPES.NO_LICENCE_MORE_THAN_15
    ) {
      newStateData.surveyPermissionsCharge = {
        ...existingSurveyPermissionsCharge,
        [surveyId]: {
          noLicenceMoreThan15WarningShown: true
        }
      };
    }
  }
  return newStateData;
};
